/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Field, Form } from 'formik';
import { Button } from 'reactstrap';
import FormikInputField from 'components/Fields/FormikInputField';
import LoadingButton from 'components/common/LoadingButton';
import CardWithTitle from 'components/CardWithTitle';

const SendEmailForm = (props) => {
  const { handleSubmit, drawerToggle, isValid, dirty, isSubmitting } = props;

  return (
    <Form onSubmit={handleSubmit}>
      <CardWithTitle>
        <Field
          label="Enter Subject"
          name="subject"
          type="text"
          component={FormikInputField}
          required
        />
        <Field
          label="Enter Body"
          name="emailBody"
          type="textarea"
          className="msg-field"
          component={FormikInputField}
          required
        />
      </CardWithTitle>

      <div className="form-btn d-flex justify-content-end mt-4">
        <Button
          color="secondary"
          outline
          size="sm"
          type="button"
          className="me-2 mw-100"
          onClick={() => drawerToggle()}
        >
          Close
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={isSubmitting}
          disabled={!isValid || !dirty || isSubmitting}
          color="warning"
          size="sm"
          type="submit"
        >
          Send Mail
        </LoadingButton>
      </div>
    </Form>
  );
};

export default SendEmailForm;
